export enum EventType {
  HAND_FINISHED = "hand.finished",
}

export enum EventVersion {
  V1_0_0 = "1.0.0",
}